'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { Component } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { EntityStatusMap, EntityStatusToStatusTagMap } from 'AdsUI/lib/Constants';
import UIDropdown from 'UIComponents/dropdown/UIDropdown';
import UICheckbox from 'UIComponents/input/UICheckbox';
import UIList from 'UIComponents/list/UIList';
import HR from 'UIComponents/elements/HR';
import { Set as ImmutableSet } from 'immutable';
import UIStatusDot from 'UIComponents/tag/UIStatusDot';
import { campaignStatus } from 'AdsUI/lib/entityStatus';
import UIInlineLabel from 'UIComponents/form/UIInlineLabel'; // Utility function to summarize actively filtered statuses so user
// understands current filters without having to drill into dropdown.

const getFilterButtonText = statuses => {
  if (statuses.size === 1) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: `filters.statusOptions.${statuses.first()}`
    });
  } else if (statuses.size > 0 && statuses.size < Object.keys(EntityStatusMap).length) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "filters.multipleStatuses",
      options: {
        count: statuses.size
      }
    });
  } else {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "filters.allStatuses"
    });
  }
};

const StatusDot = ({
  status
}) => {
  const {
    use,
    hollow
  } = EntityStatusToStatusTagMap[campaignStatus({
    status
  })];
  return /*#__PURE__*/_jsx(UIStatusDot, {
    use: use,
    hollow: hollow
  });
};

class StatusFilter extends Component {
  constructor(props) {
    super(props);
    this.onSelectAllStatuses = this.onSelectAllStatuses.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onDropdownOpenChange = this.onDropdownOpenChange.bind(this);
    this.getOption = this.getOption.bind(this);
  }

  onSelectAllStatuses() {
    this.props.onChangeStatuses(ImmutableSet(Object.keys(EntityStatusMap)));
  }

  onDropdownOpenChange() {
    const {
      statuses
    } = this.props; // If user unchecked all status filters, then default back to "All selected"
    // ie. not filtering anything out.

    if (!statuses.size) {
      this.onSelectAllStatuses();
    }
  }

  onChange(newStatus) {
    return synEvt => {
      const {
        statuses
      } = this.props;
      const updatedStatuses = synEvt.target.checked ? statuses.add(newStatus) : statuses.delete(newStatus);

      if (updatedStatuses.size) {
        this.props.onChangeStatuses(updatedStatuses);
      } else {
        this.onSelectAllStatuses();
      }
    };
  }

  getOption(status) {
    const {
      statuses
    } = this.props;
    return /*#__PURE__*/_jsxs(UICheckbox, {
      checked: statuses.has(status),
      onChange: this.onChange(status),
      children: [/*#__PURE__*/_jsx(StatusDot, {
        status: status
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: `filters.statusOptions.${status}`
      })]
    }, status);
  }

  render() {
    const {
      statuses
    } = this.props;
    const entityStatuses = Object.keys(EntityStatusMap);
    const options = entityStatuses.map(this.getOption);
    const allStatusesSelected = statuses.size === entityStatuses.length;
    return /*#__PURE__*/_jsx(UIInlineLabel, {
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "filters.statusFilterLabel"
      }),
      children: /*#__PURE__*/_jsx(UIDropdown, {
        buttonUse: "link",
        buttonText: getFilterButtonText(statuses),
        menuWidth: 250,
        children: /*#__PURE__*/_jsxs(UIList, {
          children: [/*#__PURE__*/_jsx(UICheckbox, {
            checked: allStatusesSelected,
            indeterminate: !allStatusesSelected,
            onChange: this.onSelectAllStatuses,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "filters.selectAll"
            })
          }), /*#__PURE__*/_jsx(HR, {
            distance: "extra-small"
          }), options]
        })
      })
    });
  }

}

StatusFilter.propTypes = {
  statuses: PropTypes.instanceOf(ImmutableSet).isRequired,
  onChangeStatuses: PropTypes.func.isRequired
};
export default StatusFilter;